import { TranslationKeys } from "translations";
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";

function useDueWeekText() {
  const getDueWeekText = (step: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStep) => {
    const dueText = step.dueWeek
      ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AnnualAccount.ScheduledForWeek, "", {
          weekNumber: step.dueWeek.week.toString().padStart(2, "0"),
          year: `${step.dueWeek.year}`,
        })
      : undefined;

    return dueText;
  };

  return getDueWeekText;
}

export default useDueWeekText;
